export type DeCalculatorCategory =
  | "Mathematik & Algebra"
  | "Noten & Bildung"
  | "Finanzen & Alltag"
  | "Gesundheit & Fitness"
  | "Einheiten & Physik"
  | "Umrechnung & Geometrie"
  | "Statistik & Daten"
  | "Ingenieurwesen & Elektronik"
  | "Chemie & Wissenschaft"
  | "Geschäft & Produktivität";

export interface DeCalculatorMeta {
  slug: string;
  enSlug: string;
  name: string;
  tagline: string;
  description: string;
  category: DeCalculatorCategory;
  icon: string;
  featured?: boolean;
  keywords: string[];
}

export const DE_CALCULATOR_CATEGORIES: DeCalculatorCategory[] = [
  "Mathematik & Algebra",
  "Noten & Bildung",
  "Finanzen & Alltag",
  "Gesundheit & Fitness",
  "Einheiten & Physik",
  "Umrechnung & Geometrie",
  "Statistik & Daten",
  "Ingenieurwesen & Elektronik",
  "Chemie & Wissenschaft",
  "Geschäft & Produktivität",
];

export const DE_CALCULATORS: DeCalculatorMeta[] = [
  {
    slug: "matrix-calculator",
    enSlug: "matrix-calculator",
    name: "Matrix-Rechner",
    tagline: "Matrix-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Matrix-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Mathematik & Algebra",
    icon: "Grid",
    featured: true,
    keywords: ["matrix-rechner","matrix calculator","matrix calculator","kostenloser online rechner"],
  },
  {
    slug: "logarithm-calculator",
    enSlug: "logarithm-calculator",
    name: "Logarithm & Exponential-Rechner",
    tagline: "Logarithm & Exponential-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Logarithm & Exponential-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Mathematik & Algebra",
    icon: "Binary",
    featured: true,
    keywords: ["logarithm & exponential-rechner","logarithm & exponential calculator","logarithm calculator","kostenloser online rechner"],
  },
  {
    slug: "lcm-gcd-calculator",
    enSlug: "lcm-gcd-calculator",
    name: "LCM & GCD (HCF)-Rechner",
    tagline: "LCM & GCD (HCF)-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem LCM & GCD (HCF)-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Mathematik & Algebra",
    icon: "Hash",
    featured: true,
    keywords: ["lcm & gcd (hcf)-rechner","lcm & gcd (hcf) calculator","lcm gcd calculator","kostenloser online rechner"],
  },
  {
    slug: "trigonometry-calculator",
    enSlug: "trigonometry-calculator",
    name: "Trigonometry & Right Triangle-Löser",
    tagline: "Trigonometry & Right Triangle-Löser kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Trigonometry & Right Triangle-Löser. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Mathematik & Algebra",
    icon: "Compass",
    featured: true,
    keywords: ["trigonometry & right triangle-löser","trigonometry & right triangle solver","trigonometry calculator","kostenloser online rechner"],
  },
  {
    slug: "sequence-calculator",
    enSlug: "sequence-calculator",
    name: "Sequence & Series (AP & GP)-Rechner",
    tagline: "Sequence & Series (AP & GP)-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Sequence & Series (AP & GP)-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Mathematik & Algebra",
    icon: "ListOrdered",
    featured: true,
    keywords: ["sequence & series (ap & gp)-rechner","sequence & series calculator (ap & gp)","sequence calculator","kostenloser online rechner"],
  },
  {
    slug: "percentage-calculator",
    enSlug: "percentage-calculator",
    name: "Percentage-Rechner",
    tagline: "Percentage-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Percentage-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Mathematik & Algebra",
    icon: "Percent",
    featured: true,
    keywords: ["percentage-rechner","percentage calculator","percentage calculator","kostenloser online rechner"],
  },
  {
    slug: "grade-calculator",
    enSlug: "grade-calculator",
    name: "Grade & GPA-Rechner",
    tagline: "Grade & GPA-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Grade & GPA-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Noten & Bildung",
    icon: "GraduationCap",
    featured: true,
    keywords: ["grade & gpa-rechner","grade & gpa calculator","grade calculator","kostenloser online rechner"],
  },
  {
    slug: "fraction-to-percent-calculator",
    enSlug: "fraction-to-percent-calculator",
    name: "Fraction to Percent-Rechner",
    tagline: "Fraction to Percent-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Fraction to Percent-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Mathematik & Algebra",
    icon: "Binary",
    featured: true,
    keywords: ["fraction to percent-rechner","fraction to percent calculator","fraction to percent calculator","kostenloser online rechner"],
  },
  {
    slug: "attendance-calculator",
    enSlug: "attendance-calculator",
    name: "Attendance Percentage-Rechner",
    tagline: "Attendance Percentage-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Attendance Percentage-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Noten & Bildung",
    icon: "UserCheck",
    featured: true,
    keywords: ["attendance percentage-rechner","attendance percentage calculator","attendance calculator","kostenloser online rechner"],
  },
  {
    slug: "discount-calculator",
    enSlug: "discount-calculator",
    name: "Discount & Sales Tax-Rechner",
    tagline: "Discount & Sales Tax-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Discount & Sales Tax-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Finanzen & Alltag",
    icon: "Tag",
    featured: true,
    keywords: ["discount & sales tax-rechner","discount & sales tax calculator","discount calculator","kostenloser online rechner"],
  },
  {
    slug: "age-calculator",
    enSlug: "age-calculator",
    name: "Exact Age & Birthday-Rechner",
    tagline: "Exact Age & Birthday-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Exact Age & Birthday-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Finanzen & Alltag",
    icon: "Calendar",
    featured: true,
    keywords: ["exact age & birthday-rechner","exact age & birthday calculator","age calculator","kostenloser online rechner"],
  },
  {
    slug: "ratio-calculator",
    enSlug: "ratio-calculator",
    name: "Ratio & Proportion-Rechner",
    tagline: "Ratio & Proportion-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Ratio & Proportion-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Mathematik & Algebra",
    icon: "Scale",
    featured: true,
    keywords: ["ratio & proportion-rechner","ratio & proportion calculator","ratio calculator","kostenloser online rechner"],
  },
  {
    slug: "average-calculator",
    enSlug: "average-calculator",
    name: "Average, Median & Mode-Rechner",
    tagline: "Average, Median & Mode-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Average, Median & Mode-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Mathematik & Algebra",
    icon: "BarChart3",
    featured: true,
    keywords: ["average, median & mode-rechner","average, median & mode calculator","average calculator","kostenloser online rechner"],
  },
  {
    slug: "tip-calculator",
    enSlug: "tip-calculator",
    name: "Tip & Bill Splitter-Rechner",
    tagline: "Tip & Bill Splitter-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Tip & Bill Splitter-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Finanzen & Alltag",
    icon: "Receipt",
    featured: true,
    keywords: ["tip & bill splitter-rechner","tip & bill splitter calculator","tip calculator","kostenloser online rechner"],
  },
  {
    slug: "time-calculator",
    enSlug: "time-calculator",
    name: "Time & Work Hours-Rechner",
    tagline: "Time & Work Hours-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Time & Work Hours-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Finanzen & Alltag",
    icon: "Clock",
    featured: true,
    keywords: ["time & work hours-rechner","time & work hours calculator","time calculator","kostenloser online rechner"],
  },
  {
    slug: "bmi-calculator",
    enSlug: "bmi-calculator",
    name: "BMI & Ideal Weight-Rechner",
    tagline: "BMI & Ideal Weight-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem BMI & Ideal Weight-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Finanzen & Alltag",
    icon: "HeartPulse",
    featured: true,
    keywords: ["bmi & ideal weight-rechner","bmi & ideal weight calculator","bmi calculator","kostenloser online rechner"],
  },
  {
    slug: "interest-calculator",
    enSlug: "interest-calculator",
    name: "Simple & Compound Interest-Rechner",
    tagline: "Simple & Compound Interest-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Simple & Compound Interest-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Finanzen & Alltag",
    icon: "TrendingUp",
    featured: true,
    keywords: ["simple & compound interest-rechner","simple & compound interest calculator","interest calculator","kostenloser online rechner"],
  },
  {
    slug: "cgpa-calculator",
    enSlug: "cgpa-calculator",
    name: "CGPA to Percentage-Rechner",
    tagline: "CGPA to Percentage-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem CGPA to Percentage-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Noten & Bildung",
    icon: "Award",
    featured: true,
    keywords: ["cgpa to percentage-rechner","cgpa to percentage calculator","cgpa calculator","kostenloser online rechner"],
  },
  {
    slug: "scientific-notation-calculator",
    enSlug: "scientific-notation-calculator",
    name: "Scientific Notation-Rechner",
    tagline: "Scientific Notation-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Scientific Notation-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Mathematik & Algebra",
    icon: "Atom",
    featured: true,
    keywords: ["scientific notation-rechner","scientific notation calculator","scientific notation calculator","kostenloser online rechner"],
  },
  {
    slug: "salary-calculator",
    enSlug: "salary-calculator",
    name: "Salary & Hourly Wage-Rechner",
    tagline: "Salary & Hourly Wage-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Salary & Hourly Wage-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Finanzen & Alltag",
    icon: "Wallet",
    featured: true,
    keywords: ["salary & hourly wage-rechner","salary & hourly wage calculator","salary calculator","kostenloser online rechner"],
  },
  {
    slug: "gpa-target-calculator",
    enSlug: "gpa-target-calculator",
    name: "Target GPA-Rechner",
    tagline: "Target GPA-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Target GPA-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Noten & Bildung",
    icon: "Target",
    featured: true,
    keywords: ["target gpa-rechner","target gpa calculator","gpa target calculator","kostenloser online rechner"],
  },
  {
    slug: "loan-calculator",
    enSlug: "loan-calculator",
    name: "Loan Monthly Payment-Rechner",
    tagline: "Loan Monthly Payment-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Loan Monthly Payment-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Finanzen & Alltag",
    icon: "CreditCard",
    featured: true,
    keywords: ["loan monthly payment-rechner","loan monthly payment calculator","loan calculator","kostenloser online rechner"],
  },
  {
    slug: "word-count-calculator",
    enSlug: "word-count-calculator",
    name: "Word & Character Count-Rechner",
    tagline: "Word & Character Count-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Word & Character Count-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Noten & Bildung",
    icon: "FileText",
    featured: true,
    keywords: ["word & character count-rechner","word & character count calculator","word count calculator","kostenloser online rechner"],
  },
  {
    slug: "gpa-to-percentage-calculator",
    enSlug: "gpa-to-percentage-calculator",
    name: "GPA to Percentage-Umrechner",
    tagline: "GPA to Percentage-Umrechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem GPA to Percentage-Umrechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Noten & Bildung",
    icon: "GraduationCap",
    featured: true,
    keywords: ["gpa to percentage-umrechner","gpa to percentage converter","gpa to percentage calculator","kostenloser online rechner"],
  },
  {
    slug: "pythagorean-theorem-calculator",
    enSlug: "pythagorean-theorem-calculator",
    name: "Pythagorean Theorem-Rechner",
    tagline: "Pythagorean Theorem-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Pythagorean Theorem-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Mathematik & Algebra",
    icon: "Triangle",
    featured: true,
    keywords: ["pythagorean theorem-rechner","pythagorean theorem calculator","pythagorean theorem calculator","kostenloser online rechner"],
  },
  {
    slug: "quadratic-formula-calculator",
    enSlug: "quadratic-formula-calculator",
    name: "Quadratic Equation-Löser",
    tagline: "Quadratic Equation-Löser kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Quadratic Equation-Löser. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Mathematik & Algebra",
    icon: "Variable",
    featured: true,
    keywords: ["quadratic equation-löser","quadratic equation solver","quadratic formula calculator","kostenloser online rechner"],
  },
  {
    slug: "fuel-cost-calculator",
    enSlug: "fuel-cost-calculator",
    name: "Fuel Cost & Gas Mileage-Rechner",
    tagline: "Fuel Cost & Gas Mileage-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Fuel Cost & Gas Mileage-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Finanzen & Alltag",
    icon: "Fuel",
    featured: true,
    keywords: ["fuel cost & gas mileage-rechner","fuel cost & gas mileage calculator","fuel cost calculator","kostenloser online rechner"],
  },
  {
    slug: "margin-calculator",
    enSlug: "margin-calculator",
    name: "Profit Margin & Markup-Rechner",
    tagline: "Profit Margin & Markup-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Profit Margin & Markup-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Finanzen & Alltag",
    icon: "DollarSign",
    featured: true,
    keywords: ["profit margin & markup-rechner","profit margin & markup calculator","margin calculator","kostenloser online rechner"],
  },
  {
    slug: "pace-calculator",
    enSlug: "pace-calculator",
    name: "Running Pace & Speed-Rechner",
    tagline: "Running Pace & Speed-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Running Pace & Speed-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Finanzen & Alltag",
    icon: "Timer",
    featured: true,
    keywords: ["running pace & speed-rechner","running pace & speed calculator","pace calculator","kostenloser online rechner"],
  },
  {
    slug: "calorie-calculator",
    enSlug: "calorie-calculator",
    name: "Daily Calorie & BMR-Rechner",
    tagline: "Daily Calorie & BMR-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Daily Calorie & BMR-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Gesundheit & Fitness",
    icon: "Flame",
    featured: true,
    keywords: ["daily calorie & bmr-rechner","daily calorie & bmr calculator","calorie calculator","kostenloser online rechner"],
  },
  {
    slug: "water-intake-calculator",
    enSlug: "water-intake-calculator",
    name: "Daily Water Intake-Rechner",
    tagline: "Daily Water Intake-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Daily Water Intake-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Gesundheit & Fitness",
    icon: "Droplets",
    featured: true,
    keywords: ["daily water intake-rechner","daily water intake calculator","water intake calculator","kostenloser online rechner"],
  },
  {
    slug: "body-fat-calculator",
    enSlug: "body-fat-calculator",
    name: "Body Fat Percentage-Rechner",
    tagline: "Body Fat Percentage-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Body Fat Percentage-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Gesundheit & Fitness",
    icon: "Activity",
    featured: true,
    keywords: ["body fat percentage-rechner","body fat percentage calculator","body fat calculator","kostenloser online rechner"],
  },
  {
    slug: "velocity-acceleration-calculator",
    enSlug: "velocity-acceleration-calculator",
    name: "Speed, Velocity & Acceleration-Rechner",
    tagline: "Speed, Velocity & Acceleration-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Speed, Velocity & Acceleration-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Einheiten & Physik",
    icon: "Zap",
    featured: true,
    keywords: ["speed, velocity & acceleration-rechner","speed, velocity & acceleration calculator","velocity acceleration calculator","kostenloser online rechner"],
  },
  {
    slug: "density-calculator",
    enSlug: "density-calculator",
    name: "Density, Mass & Volume-Rechner",
    tagline: "Density, Mass & Volume-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Density, Mass & Volume-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Einheiten & Physik",
    icon: "Box",
    featured: true,
    keywords: ["density, mass & volume-rechner","density, mass & volume calculator","density calculator","kostenloser online rechner"],
  },
  {
    slug: "gpa-to-letter-calculator",
    enSlug: "gpa-to-letter-calculator",
    name: "Percentage to Letter Grade-Umrechner",
    tagline: "Percentage to Letter Grade-Umrechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Percentage to Letter Grade-Umrechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Noten & Bildung",
    icon: "CheckCircle2",
    featured: true,
    keywords: ["percentage to letter grade-umrechner","percentage to letter grade converter","gpa to letter calculator","kostenloser online rechner"],
  },
  {
    slug: "ideal-weight-calculator",
    enSlug: "ideal-weight-calculator",
    name: "Ideal Body Weight (IBW)-Rechner",
    tagline: "Ideal Body Weight (IBW)-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Ideal Body Weight (IBW)-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Gesundheit & Fitness",
    icon: "Heart",
    featured: true,
    keywords: ["ideal body weight (ibw)-rechner","ideal body weight (ibw) calculator","ideal weight calculator","kostenloser online rechner"],
  },
  {
    slug: "macro-calculator",
    enSlug: "macro-calculator",
    name: "Macronutrient Ratio-Rechner",
    tagline: "Macronutrient Ratio-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Macronutrient Ratio-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Gesundheit & Fitness",
    icon: "Apple",
    featured: true,
    keywords: ["macronutrient ratio-rechner","macronutrient ratio calculator","macro calculator","kostenloser online rechner"],
  },
  {
    slug: "weight-loss-calculator",
    enSlug: "weight-loss-calculator",
    name: "Weight Loss & Target Date Planner-Rechner",
    tagline: "Weight Loss & Target Date Planner-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Weight Loss & Target Date Planner-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Gesundheit & Fitness",
    icon: "TrendingDown",
    featured: true,
    keywords: ["weight loss & target date planner-rechner","weight loss calculator & target date planner","weight loss calculator","kostenloser online rechner"],
  },
  {
    slug: "height-calculator",
    enSlug: "height-calculator",
    name: "Child & Adult Height Predictor-Rechner",
    tagline: "Child & Adult Height Predictor-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Child & Adult Height Predictor-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Gesundheit & Fitness",
    icon: "Ruler",
    featured: true,
    keywords: ["child & adult height predictor-rechner","child & adult height predictor calculator","height calculator","kostenloser online rechner"],
  },
  {
    slug: "height-comparison-calculator",
    enSlug: "height-comparison-calculator",
    name: "Height Comparison (Side by Side)-Rechner",
    tagline: "Height Comparison (Side by Side)-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Height Comparison (Side by Side)-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Gesundheit & Fitness",
    icon: "Ruler",
    featured: true,
    keywords: ["height comparison (side by side)-rechner","height comparison calculator (side by side)","height comparison calculator","kostenloser online rechner"],
  },
  {
    slug: "army-body-fat-calculator",
    enSlug: "army-body-fat-calculator",
    name: "US Army Body Fat-Rechner",
    tagline: "US Army Body Fat-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem US Army Body Fat-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Gesundheit & Fitness",
    icon: "ShieldCheck",
    featured: true,
    keywords: ["us army body fat-rechner","us army body fat calculator","army body fat calculator","kostenloser online rechner"],
  },
  {
    slug: "keto-calculator",
    enSlug: "keto-calculator",
    name: "Keto Macro & Net Carb-Rechner",
    tagline: "Keto Macro & Net Carb-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Keto Macro & Net Carb-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Gesundheit & Fitness",
    icon: "Flame",
    featured: true,
    keywords: ["keto macro & net carb-rechner","keto macro & net carb calculator","keto calculator","kostenloser online rechner"],
  },
  {
    slug: "height-percentile-calculator",
    enSlug: "height-percentile-calculator",
    name: "Height Percentile (CDC & WHO)-Rechner",
    tagline: "Height Percentile (CDC & WHO)-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Height Percentile (CDC & WHO)-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Gesundheit & Fitness",
    icon: "BarChart2",
    featured: true,
    keywords: ["height percentile (cdc & who)-rechner","height percentile calculator (cdc & who)","height percentile calculator","kostenloser online rechner"],
  },
  {
    slug: "body-surface-area-calculator",
    enSlug: "body-surface-area-calculator",
    name: "Body Surface Area (BSA)-Rechner",
    tagline: "Body Surface Area (BSA)-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Body Surface Area (BSA)-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Gesundheit & Fitness",
    icon: "Square",
    featured: true,
    keywords: ["body surface area (bsa)-rechner","body surface area (bsa) calculator","body surface area calculator","kostenloser online rechner"],
  },
  {
    slug: "total-body-water-calculator",
    enSlug: "total-body-water-calculator",
    name: "Total Body Water (TBW)-Rechner",
    tagline: "Total Body Water (TBW)-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Total Body Water (TBW)-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Gesundheit & Fitness",
    icon: "Droplet",
    featured: true,
    keywords: ["total body water (tbw)-rechner","total body water (tbw) calculator","total body water calculator","kostenloser online rechner"],
  },
  {
    slug: "healthy-weight-calculator",
    enSlug: "healthy-weight-calculator",
    name: "Healthy Weight & Range Finder-Rechner",
    tagline: "Healthy Weight & Range Finder-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Healthy Weight & Range Finder-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Gesundheit & Fitness",
    icon: "Activity",
    featured: true,
    keywords: ["healthy weight & range finder-rechner","healthy weight calculator & range finder","healthy weight calculator","kostenloser online rechner"],
  },
  {
    slug: "ohms-law-calculator",
    enSlug: "ohms-law-calculator",
    name: "Ohm's Law & Power-Rechner",
    tagline: "Ohm's Law & Power-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Ohm's Law & Power-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Einheiten & Physik",
    icon: "Cpu",
    featured: true,
    keywords: ["ohm's law & power-rechner","ohm's law & power calculator","ohms law calculator","kostenloser online rechner"],
  },
  {
    slug: "convert-temperature-calculator",
    enSlug: "convert-temperature-calculator",
    name: "Temperature-Rechner",
    tagline: "Temperature-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Temperature-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Einheiten & Physik",
    icon: "Thermometer",
    featured: true,
    keywords: ["temperature-rechner","temperature converter calculator","convert temperature calculator","kostenloser online rechner"],
  },
  {
    slug: "simple-interest-calculator",
    enSlug: "simple-interest-calculator",
    name: "Simple Interest Loan & Savings-Rechner",
    tagline: "Simple Interest Loan & Savings-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Simple Interest Loan & Savings-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Finanzen & Alltag",
    icon: "Coins",
    featured: true,
    keywords: ["simple interest loan & savings-rechner","simple interest loan & savings calculator","simple interest calculator","kostenloser online rechner"],
  },
  {
    slug: "percentage-error-calculator",
    enSlug: "percentage-error-calculator",
    name: "Percentage Error-Rechner",
    tagline: "Percentage Error-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Percentage Error-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Mathematik & Algebra",
    icon: "Percent",
    featured: true,
    keywords: ["percentage error-rechner","percentage error calculator","percentage error calculator","kostenloser online rechner"],
  },
  {
    slug: "length-converter-calculator",
    enSlug: "length-converter-calculator",
    name: "Length & Distance-Umrechner",
    tagline: "Length & Distance-Umrechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Length & Distance-Umrechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Umrechnung & Geometrie",
    icon: "Ruler",
    featured: true,
    keywords: ["length & distance-umrechner","length & distance converter","length converter calculator","kostenloser online rechner"],
  },
  {
    slug: "area-calculator",
    enSlug: "area-calculator",
    name: "2D Surface Area-Rechner",
    tagline: "2D Surface Area-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem 2D Surface Area-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Umrechnung & Geometrie",
    icon: "Shapes",
    featured: true,
    keywords: ["2d surface area-rechner","2d surface area calculator","area calculator","kostenloser online rechner"],
  },
  {
    slug: "volume-3d-calculator",
    enSlug: "volume-3d-calculator",
    name: "3D Volume-Rechner",
    tagline: "3D Volume-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem 3D Volume-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Umrechnung & Geometrie",
    icon: "BoxSelect",
    featured: true,
    keywords: ["3d volume-rechner","3d volume calculator","volume 3d calculator","kostenloser online rechner"],
  },
  {
    slug: "scientific-calculator",
    enSlug: "scientific-calculator",
    name: "Scientific Function-Rechner",
    tagline: "Scientific Function-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Scientific Function-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Mathematik & Algebra",
    icon: "Calculator",
    featured: true,
    keywords: ["scientific function-rechner","scientific function calculator","scientific calculator","kostenloser online rechner"],
  },
  {
    slug: "exponent-calculator",
    enSlug: "exponent-calculator",
    name: "Exponent & Power-Rechner",
    tagline: "Exponent & Power-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Exponent & Power-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Mathematik & Algebra",
    icon: "Superscript",
    featured: true,
    keywords: ["exponent & power-rechner","exponent & power calculator","exponent calculator","kostenloser online rechner"],
  },
  {
    slug: "gpa-to-4-scale-calculator",
    enSlug: "gpa-to-4-scale-calculator",
    name: "Marks & 5-Point to 4.0 GPA-Umrechner",
    tagline: "Marks & 5-Point to 4.0 GPA-Umrechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Marks & 5-Point to 4.0 GPA-Umrechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Noten & Bildung",
    icon: "Award",
    featured: true,
    keywords: ["marks & 5-point to 4.0 gpa-umrechner","marks & 5-point to 4.0 gpa converter","gpa to 4 scale calculator","kostenloser online rechner"],
  },
  {
    slug: "standard-deviation-calculator",
    enSlug: "standard-deviation-calculator",
    name: "Standard Deviation & Variance-Rechner",
    tagline: "Standard Deviation & Variance-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Standard Deviation & Variance-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Statistik & Daten",
    icon: "BarChart2",
    featured: true,
    keywords: ["standard deviation & variance-rechner","standard deviation & variance calculator","standard deviation calculator","kostenloser online rechner"],
  },
  {
    slug: "probability-calculator",
    enSlug: "probability-calculator",
    name: "Probability & Odds-Rechner",
    tagline: "Probability & Odds-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Probability & Odds-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Statistik & Daten",
    icon: "PieChart",
    featured: true,
    keywords: ["probability & odds-rechner","probability & odds calculator","probability calculator","kostenloser online rechner"],
  },
  {
    slug: "npr-ncr-calculator",
    enSlug: "npr-ncr-calculator",
    name: "Permutation & Combination (nPr / nCr)-Rechner",
    tagline: "Permutation & Combination (nPr / nCr)-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Permutation & Combination (nPr / nCr)-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Statistik & Daten",
    icon: "Binary",
    featured: true,
    keywords: ["permutation & combination (npr / ncr)-rechner","permutation & combination (npr / ncr) calculator","npr ncr calculator","kostenloser online rechner"],
  },
  {
    slug: "resistor-color-code-calculator",
    enSlug: "resistor-color-code-calculator",
    name: "Resistor Color Code-Rechner",
    tagline: "Resistor Color Code-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Resistor Color Code-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Ingenieurwesen & Elektronik",
    icon: "Cpu",
    featured: true,
    keywords: ["resistor color code-rechner","resistor color code calculator","resistor color code calculator","kostenloser online rechner"],
  },
  {
    slug: "voltage-drop-calculator",
    enSlug: "voltage-drop-calculator",
    name: "Wire Voltage Drop & Size-Rechner",
    tagline: "Wire Voltage Drop & Size-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Wire Voltage Drop & Size-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Ingenieurwesen & Elektronik",
    icon: "Zap",
    featured: true,
    keywords: ["wire voltage drop & size-rechner","wire voltage drop & size calculator","voltage drop calculator","kostenloser online rechner"],
  },
  {
    slug: "power-factor-calculator",
    enSlug: "power-factor-calculator",
    name: "Power Factor (PF) & kVAR Correction-Rechner",
    tagline: "Power Factor (PF) & kVAR Correction-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Power Factor (PF) & kVAR Correction-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Ingenieurwesen & Elektronik",
    icon: "Activity",
    featured: true,
    keywords: ["power factor (pf) & kvar correction-rechner","power factor (pf) & kvar correction calculator","power factor calculator","kostenloser online rechner"],
  },
  {
    slug: "molarity-calculator",
    enSlug: "molarity-calculator",
    name: "Molarity & Solution Concentration-Rechner",
    tagline: "Molarity & Solution Concentration-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Molarity & Solution Concentration-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Chemie & Wissenschaft",
    icon: "FlaskConical",
    featured: true,
    keywords: ["molarity & solution concentration-rechner","molarity & solution concentration calculator","molarity calculator","kostenloser online rechner"],
  },
  {
    slug: "ph-calculator",
    enSlug: "ph-calculator",
    name: "pH, pOH & Hydrogen Ion [H+]-Rechner",
    tagline: "pH, pOH & Hydrogen Ion [H+]-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem pH, pOH & Hydrogen Ion [H+]-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Chemie & Wissenschaft",
    icon: "TestTube",
    featured: true,
    keywords: ["ph, poh & hydrogen ion [h+]-rechner","ph, poh & hydrogen ion [h+] calculator","ph calculator","kostenloser online rechner"],
  },
  {
    slug: "ideal-gas-law-calculator",
    enSlug: "ideal-gas-law-calculator",
    name: "Ideal Gas Law (PV = nRT)-Rechner",
    tagline: "Ideal Gas Law (PV = nRT)-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Ideal Gas Law (PV = nRT)-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Chemie & Wissenschaft",
    icon: "Flame",
    featured: true,
    keywords: ["ideal gas law (pv = nrt)-rechner","ideal gas law (pv = nrt) calculator","ideal gas law calculator","kostenloser online rechner"],
  },
  {
    slug: "roi-calculator",
    enSlug: "roi-calculator",
    name: "ROI (Return on Investment)-Rechner",
    tagline: "ROI (Return on Investment)-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem ROI (Return on Investment)-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Geschäft & Produktivität",
    icon: "TrendingUp",
    featured: true,
    keywords: ["roi (return on investment)-rechner","roi (return on investment) calculator","roi calculator","kostenloser online rechner"],
  },
  {
    slug: "cpm-calculator",
    enSlug: "cpm-calculator",
    name: "CPM (Cost Per Mille / Thousand)-Rechner",
    tagline: "CPM (Cost Per Mille / Thousand)-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem CPM (Cost Per Mille / Thousand)-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Geschäft & Produktivität",
    icon: "Target",
    featured: true,
    keywords: ["cpm (cost per mille / thousand)-rechner","cpm (cost per mille / thousand) calculator","cpm calculator","kostenloser online rechner"],
  },
  {
    slug: "breakeven-calculator",
    enSlug: "breakeven-calculator",
    name: "Breakeven Point & Profit Margin-Rechner",
    tagline: "Breakeven Point & Profit Margin-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Breakeven Point & Profit Margin-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Geschäft & Produktivität",
    icon: "DollarSign",
    featured: true,
    keywords: ["breakeven point & profit margin-rechner","breakeven point & profit margin calculator","breakeven calculator","kostenloser online rechner"],
  },
  {
    slug: "mortgage-calculator",
    enSlug: "mortgage-calculator",
    name: "Mortgage & Loan Amortization-Rechner",
    tagline: "Mortgage & Loan Amortization-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Mortgage & Loan Amortization-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Finanzen & Alltag",
    icon: "Home",
    featured: true,
    keywords: ["mortgage & loan amortization-rechner","mortgage & loan amortization calculator","mortgage calculator","kostenloser online rechner"],
  },
  {
    slug: "compound-interest-calculator",
    enSlug: "compound-interest-calculator",
    name: "Compound Interest & Savings Growth-Rechner",
    tagline: "Compound Interest & Savings Growth-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Compound Interest & Savings Growth-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Finanzen & Alltag",
    icon: "TrendingUp",
    featured: true,
    keywords: ["compound interest & savings growth-rechner","compound interest & savings growth calculator","compound interest calculator","kostenloser online rechner"],
  },
  {
    slug: "tdee-calculator",
    enSlug: "tdee-calculator",
    name: "TDEE & BMR Calorie-Rechner",
    tagline: "TDEE & BMR Calorie-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem TDEE & BMR Calorie-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Gesundheit & Fitness",
    icon: "Flame",
    featured: true,
    keywords: ["tdee & bmr calorie-rechner","tdee & bmr calorie calculator","tdee calculator","kostenloser online rechner"],
  },
  {
    slug: "inflation-calculator",
    enSlug: "inflation-calculator",
    name: "Inflation & Purchasing Power-Rechner",
    tagline: "Inflation & Purchasing Power-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Inflation & Purchasing Power-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Finanzen & Alltag",
    icon: "ArrowDownRight",
    featured: true,
    keywords: ["inflation & purchasing power-rechner","inflation & purchasing power calculator","inflation calculator","kostenloser online rechner"],
  },
  {
    slug: "linear-equations-calculator",
    enSlug: "linear-equations-calculator",
    name: "System of Linear Equations-Löser",
    tagline: "System of Linear Equations-Löser kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem System of Linear Equations-Löser. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Mathematik & Algebra",
    icon: "Binary",
    featured: true,
    keywords: ["system of linear equations-löser","system of linear equations solver","linear equations calculator","kostenloser online rechner"],
  },
  {
    slug: "vector-calculator",
    enSlug: "vector-calculator",
    name: "2D & 3D Vector Math-Rechner",
    tagline: "2D & 3D Vector Math-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem 2D & 3D Vector Math-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Einheiten & Physik",
    icon: "Compass",
    featured: true,
    keywords: ["2d & 3d vector math-rechner","2d & 3d vector math calculator","vector calculator","kostenloser online rechner"],
  },
  {
    slug: "auto-loan-calculator",
    enSlug: "auto-loan-calculator",
    name: "Auto Loan & Car Payment-Rechner",
    tagline: "Auto Loan & Car Payment-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Auto Loan & Car Payment-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Finanzen & Alltag",
    icon: "Car",
    featured: true,
    keywords: ["auto loan & car payment-rechner","auto loan & car payment calculator","auto loan calculator","kostenloser online rechner"],
  },
  {
    slug: "macro-ratio-calculator",
    enSlug: "macro-ratio-calculator",
    name: "Macronutrient & Meal Ratio-Rechner",
    tagline: "Macronutrient & Meal Ratio-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Macronutrient & Meal Ratio-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Gesundheit & Fitness",
    icon: "Utensils",
    featured: true,
    keywords: ["macronutrient & meal ratio-rechner","macronutrient & meal ratio calculator","macro ratio calculator","kostenloser online rechner"],
  },
  {
    slug: "percentage-change-calculator",
    enSlug: "percentage-change-calculator",
    name: "Percentage Change & Difference-Rechner",
    tagline: "Percentage Change & Difference-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Percentage Change & Difference-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Mathematik & Algebra",
    icon: "Percent",
    featured: true,
    keywords: ["percentage change & difference-rechner","percentage change & difference calculator","percentage change calculator","kostenloser online rechner"],
  },
  {
    slug: "fire-calculator",
    enSlug: "fire-calculator",
    name: "FIRE & Retirement Nest Egg-Rechner",
    tagline: "FIRE & Retirement Nest Egg-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem FIRE & Retirement Nest Egg-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Finanzen & Alltag",
    icon: "Flame",
    featured: true,
    keywords: ["fire & retirement nest egg-rechner","fire & retirement nest egg calculator","fire calculator","kostenloser online rechner"],
  },
  {
    slug: "loan-payoff-calculator",
    enSlug: "loan-payoff-calculator",
    name: "Loan Payoff & Extra Payment-Rechner",
    tagline: "Loan Payoff & Extra Payment-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Loan Payoff & Extra Payment-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Finanzen & Alltag",
    icon: "Sparkles",
    featured: true,
    keywords: ["loan payoff & extra payment-rechner","loan payoff & extra payment calculator","loan payoff calculator","kostenloser online rechner"],
  },
  {
    slug: "kinetic-energy-calculator",
    enSlug: "kinetic-energy-calculator",
    name: "Kinetic Energy & Momentum Physics-Rechner",
    tagline: "Kinetic Energy & Momentum Physics-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Kinetic Energy & Momentum Physics-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Einheiten & Physik",
    icon: "Zap",
    featured: true,
    keywords: ["kinetic energy & momentum physics-rechner","kinetic energy & momentum physics calculator","kinetic energy calculator","kostenloser online rechner"],
  },
  {
    slug: "sales-tax-calculator",
    enSlug: "sales-tax-calculator",
    name: "Sales Tax & Reverse Tax-Rechner",
    tagline: "Sales Tax & Reverse Tax-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Sales Tax & Reverse Tax-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Finanzen & Alltag",
    icon: "Tag",
    featured: true,
    keywords: ["sales tax & reverse tax-rechner","sales tax & reverse tax calculator","sales tax calculator","kostenloser online rechner"],
  },
  {
    slug: "restaurant-tip-calculator",
    enSlug: "restaurant-tip-calculator",
    name: "Restaurant Tip & Bill Splitter-Rechner",
    tagline: "Restaurant Tip & Bill Splitter-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Restaurant Tip & Bill Splitter-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Finanzen & Alltag",
    icon: "Utensils",
    featured: true,
    keywords: ["restaurant tip & bill splitter-rechner","restaurant tip & bill splitter calculator","restaurant tip calculator","kostenloser online rechner"],
  },
  {
    slug: "gpa-conversion-calculator",
    enSlug: "gpa-conversion-calculator",
    name: "GPA, CGPA & 10-Point Scale Conversion-Rechner",
    tagline: "GPA, CGPA & 10-Point Scale Conversion-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem GPA, CGPA & 10-Point Scale Conversion-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Noten & Bildung",
    icon: "Award",
    featured: true,
    keywords: ["gpa, cgpa & 10-point scale conversion-rechner","gpa, cgpa & 10-point scale conversion calculator","gpa conversion calculator","kostenloser online rechner"],
  },
  {
    slug: "calorie-deficit-calculator",
    enSlug: "calorie-deficit-calculator",
    name: "Calorie Deficit & Weight Loss Target Date-Rechner",
    tagline: "Calorie Deficit & Weight Loss Target Date-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Calorie Deficit & Weight Loss Target Date-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Gesundheit & Fitness",
    icon: "Target",
    featured: true,
    keywords: ["calorie deficit & weight loss target date-rechner","calorie deficit & weight loss target date calculator","calorie deficit calculator","kostenloser online rechner"],
  },
  {
    slug: "quadratic-solver-calculator",
    enSlug: "quadratic-solver-calculator",
    name: "Quadratic Equation & Parabola Vertex-Löser",
    tagline: "Quadratic Equation & Parabola Vertex-Löser kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Quadratic Equation & Parabola Vertex-Löser. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Mathematik & Algebra",
    icon: "Binary",
    featured: true,
    keywords: ["quadratic equation & parabola vertex-löser","quadratic equation & parabola vertex solver","quadratic solver calculator","kostenloser online rechner"],
  },
  {
    slug: "work-power-calculator",
    enSlug: "work-power-calculator",
    name: "Work, Power & Horsepower Physics-Rechner",
    tagline: "Work, Power & Horsepower Physics-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Work, Power & Horsepower Physics-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Einheiten & Physik",
    icon: "Zap",
    featured: true,
    keywords: ["work, power & horsepower physics-rechner","work, power & horsepower physics calculator","work power calculator","kostenloser online rechner"],
  },
  {
    slug: "mortgage-refinance-calculator",
    enSlug: "mortgage-refinance-calculator",
    name: "Mortgage Refinance & Break-Even-Rechner",
    tagline: "Mortgage Refinance & Break-Even-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Mortgage Refinance & Break-Even-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Finanzen & Alltag",
    icon: "RefreshCw",
    featured: true,
    keywords: ["mortgage refinance & break-even-rechner","mortgage refinance & break-even calculator","mortgage refinance calculator","kostenloser online rechner"],
  },
  {
    slug: "ideal-body-weight-calculator",
    enSlug: "ideal-body-weight-calculator",
    name: "Ideal Body Weight (IBW)-Rechner",
    tagline: "Ideal Body Weight (IBW)-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Ideal Body Weight (IBW)-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Gesundheit & Fitness",
    icon: "HeartPulse",
    featured: true,
    keywords: ["ideal body weight (ibw)-rechner","ideal body weight (ibw) calculator","ideal body weight calculator","kostenloser online rechner"],
  },
  {
    slug: "fraction-arithmetic-calculator",
    enSlug: "fraction-arithmetic-calculator",
    name: "Fraction & Mixed Number Arithmetic-Rechner",
    tagline: "Fraction & Mixed Number Arithmetic-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Fraction & Mixed Number Arithmetic-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Mathematik & Algebra",
    icon: "Binary",
    featured: true,
    keywords: ["fraction & mixed number arithmetic-rechner","fraction & mixed number arithmetic calculator","fraction arithmetic calculator","kostenloser online rechner"],
  },
  {
    slug: "cagr-calculator",
    enSlug: "cagr-calculator",
    name: "Compound Annual Growth Rate (CAGR)-Rechner",
    tagline: "Compound Annual Growth Rate (CAGR)-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Compound Annual Growth Rate (CAGR)-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Geschäft & Produktivität",
    icon: "TrendingUp",
    featured: true,
    keywords: ["compound annual growth rate (cagr)-rechner","compound annual growth rate (cagr) calculator","cagr calculator","kostenloser online rechner"],
  },
  {
    slug: "wave-speed-calculator",
    enSlug: "wave-speed-calculator",
    name: "Wavelength, Frequency & Wave Speed Physics-Rechner",
    tagline: "Wavelength, Frequency & Wave Speed Physics-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Wavelength, Frequency & Wave Speed Physics-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Einheiten & Physik",
    icon: "Activity",
    featured: true,
    keywords: ["wavelength, frequency & wave speed physics-rechner","wavelength, frequency & wave speed physics calculator","wave speed calculator","kostenloser online rechner"],
  },
  {
    slug: "dti-calculator",
    enSlug: "dti-calculator",
    name: "Debt-to-Income (DTI) Ratio-Rechner",
    tagline: "Debt-to-Income (DTI) Ratio-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Debt-to-Income (DTI) Ratio-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Finanzen & Alltag",
    icon: "ShieldCheck",
    featured: true,
    keywords: ["debt-to-income (dti) ratio-rechner","debt-to-income (dti) ratio calculator","dti calculator","kostenloser online rechner"],
  },
  {
    slug: "paycheck-calculator",
    enSlug: "paycheck-calculator",
    name: "Paycheck & Take-Home Pay-Rechner",
    tagline: "Paycheck & Take-Home Pay-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Paycheck & Take-Home Pay-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Finanzen & Alltag",
    icon: "Wallet",
    featured: true,
    keywords: ["paycheck & take-home pay-rechner","paycheck & take-home pay calculator","paycheck calculator","kostenloser online rechner"],
  },
  {
    slug: "water-retention-calculator",
    enSlug: "water-retention-calculator",
    name: "Water Weight & Fluid Retention-Rechner",
    tagline: "Water Weight & Fluid Retention-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Water Weight & Fluid Retention-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Gesundheit & Fitness",
    icon: "Droplets",
    featured: true,
    keywords: ["water weight & fluid retention-rechner","water weight & fluid retention calculator","water retention calculator","kostenloser online rechner"],
  },
  {
    slug: "polynomial-calculator",
    enSlug: "polynomial-calculator",
    name: "Polynomial & Synthetic Division-Rechner",
    tagline: "Polynomial & Synthetic Division-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Polynomial & Synthetic Division-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Mathematik & Algebra",
    icon: "Binary",
    featured: true,
    keywords: ["polynomial & synthetic division-rechner","polynomial solver & synthetic division calculator","polynomial calculator","kostenloser online rechner"],
  },
  {
    slug: "car-depreciation-calculator",
    enSlug: "car-depreciation-calculator",
    name: "Car Depreciation & Resale Value-Rechner",
    tagline: "Car Depreciation & Resale Value-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Car Depreciation & Resale Value-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Finanzen & Alltag",
    icon: "Car",
    featured: true,
    keywords: ["car depreciation & resale value-rechner","car depreciation & resale value calculator","car depreciation calculator","kostenloser online rechner"],
  },
  {
    slug: "weighted-gpa-calculator",
    enSlug: "weighted-gpa-calculator",
    name: "Weighted vs Unweighted GPA-Rechner",
    tagline: "Weighted vs Unweighted GPA-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Weighted vs Unweighted GPA-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Noten & Bildung",
    icon: "GraduationCap",
    featured: true,
    keywords: ["weighted vs unweighted gpa-rechner","weighted vs unweighted gpa calculator","weighted gpa calculator","kostenloser online rechner"],
  },
  {
    slug: "torque-calculator",
    enSlug: "torque-calculator",
    name: "Torque & Rotational Dynamics Physics-Rechner",
    tagline: "Torque & Rotational Dynamics Physics-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Torque & Rotational Dynamics Physics-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Einheiten & Physik",
    icon: "RotateCw",
    featured: true,
    keywords: ["torque & rotational dynamics physics-rechner","torque & rotational dynamics physics calculator","torque calculator","kostenloser online rechner"],
  },
  {
    slug: "half-life-calculator",
    enSlug: "half-life-calculator",
    name: "Radioactive Half-Life & Decay-Rechner",
    tagline: "Radioactive Half-Life & Decay-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Radioactive Half-Life & Decay-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Chemie & Wissenschaft",
    icon: "Atom",
    featured: true,
    keywords: ["radioactive half-life & decay-rechner","radioactive half-life & decay calculator","half life calculator","kostenloser online rechner"],
  },
  {
    slug: "amortization-schedule-calculator",
    enSlug: "amortization-schedule-calculator",
    name: "Loan & Mortgage Amortization Schedule-Rechner",
    tagline: "Loan & Mortgage Amortization Schedule-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Loan & Mortgage Amortization Schedule-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Finanzen & Alltag",
    icon: "Table",
    featured: true,
    keywords: ["loan & mortgage amortization schedule-rechner","loan & mortgage amortization schedule calculator","amortization schedule calculator","kostenloser online rechner"],
  },
  {
    slug: "bmi-percentile-calculator",
    enSlug: "bmi-percentile-calculator",
    name: "Child & Teen BMI Percentile (CDC & WHO)-Rechner",
    tagline: "Child & Teen BMI Percentile (CDC & WHO)-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Child & Teen BMI Percentile (CDC & WHO)-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Gesundheit & Fitness",
    icon: "HeartPulse",
    featured: true,
    keywords: ["child & teen bmi percentile (cdc & who)-rechner","child & teen bmi percentile calculator (cdc & who)","bmi percentile calculator","kostenloser online rechner"],
  },
  {
    slug: "matrix-determinant-calculator",
    enSlug: "matrix-determinant-calculator",
    name: "Matrix Determinant & Transpose-Rechner",
    tagline: "Matrix Determinant & Transpose-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Matrix Determinant & Transpose-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Mathematik & Algebra",
    icon: "Grid",
    featured: true,
    keywords: ["matrix determinant & transpose-rechner","matrix determinant & transpose calculator","matrix determinant calculator","kostenloser online rechner"],
  },
  {
    slug: "calories-burned-calculator",
    enSlug: "calories-burned-calculator",
    name: "Exercise Calories Burned & MET-Rechner",
    tagline: "Exercise Calories Burned & MET-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Exercise Calories Burned & MET-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Gesundheit & Fitness",
    icon: "Flame",
    featured: true,
    keywords: ["exercise calories burned & met-rechner","exercise calories burned & met calculator","calories burned calculator","kostenloser online rechner"],
  },
  {
    slug: "electricity-cost-calculator",
    enSlug: "electricity-cost-calculator",
    name: "Appliance Electricity & Power Cost-Rechner",
    tagline: "Appliance Electricity & Power Cost-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Appliance Electricity & Power Cost-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Finanzen & Alltag",
    icon: "Zap",
    featured: true,
    keywords: ["appliance electricity & power cost-rechner","appliance electricity & power cost calculator","electricity cost calculator","kostenloser online rechner"],
  },
  {
    slug: "dilution-calculator",
    enSlug: "dilution-calculator",
    name: "Solution Dilution (C₁V₁ = C₂V₂)-Rechner",
    tagline: "Solution Dilution (C₁V₁ = C₂V₂)-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Solution Dilution (C₁V₁ = C₂V₂)-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Chemie & Wissenschaft",
    icon: "FlaskConical",
    featured: true,
    keywords: ["solution dilution (c₁v₁ = c₂v₂)-rechner","solution dilution calculator (c₁v₁ = c₂v₂)","dilution calculator","kostenloser online rechner"],
  },
  {
    slug: "rc-circuit-calculator",
    enSlug: "rc-circuit-calculator",
    name: "RC Circuit Time Constant (τ = R·C)-Rechner",
    tagline: "RC Circuit Time Constant (τ = R·C)-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem RC Circuit Time Constant (τ = R·C)-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Ingenieurwesen & Elektronik",
    icon: "Cpu",
    featured: true,
    keywords: ["rc circuit time constant (τ = r·c)-rechner","rc circuit time constant (τ = r·c) calculator","rc circuit calculator","kostenloser online rechner"],
  },
  {
    slug: "gpa-semester-calculator",
    enSlug: "gpa-semester-calculator",
    name: "Semester & Term GPA-Rechner",
    tagline: "Semester & Term GPA-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Semester & Term GPA-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Noten & Bildung",
    icon: "GraduationCap",
    featured: true,
    keywords: ["semester & term gpa-rechner","semester & term gpa calculator","gpa semester calculator","kostenloser online rechner"],
  },
  {
    slug: "stoichiometry-calculator",
    enSlug: "stoichiometry-calculator",
    name: "Stoichiometry & Theoretical Yield-Rechner",
    tagline: "Stoichiometry & Theoretical Yield-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Stoichiometry & Theoretical Yield-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Chemie & Wissenschaft",
    icon: "FlaskConical",
    featured: true,
    keywords: ["stoichiometry & theoretical yield-rechner","stoichiometry & theoretical yield calculator","stoichiometry calculator","kostenloser online rechner"],
  },
  {
    slug: "logic-gate-calculator",
    enSlug: "logic-gate-calculator",
    name: "Boolean Logic Gate & Truth Table Generator Rechner",
    tagline: "Boolean Logic Gate & Truth Table Generator Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Boolean Logic Gate & Truth Table Generator Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Ingenieurwesen & Elektronik",
    icon: "Cpu",
    featured: true,
    keywords: ["boolean logic gate & truth table generator rechner","boolean logic gate & truth table generator","logic gate calculator","kostenloser online rechner"],
  },
  {
    slug: "ellipse-calculator",
    enSlug: "ellipse-calculator",
    name: "Ellipse Area, Perimeter & Foci-Rechner",
    tagline: "Ellipse Area, Perimeter & Foci-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Ellipse Area, Perimeter & Foci-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Umrechnung & Geometrie",
    icon: "Shapes",
    featured: true,
    keywords: ["ellipse area, perimeter & foci-rechner","ellipse area, perimeter & foci calculator","ellipse calculator","kostenloser online rechner"],
  },
  {
    slug: "buffer-ph-calculator",
    enSlug: "buffer-ph-calculator",
    name: "Henderson-Hasselbalch Buffer pH-Rechner",
    tagline: "Henderson-Hasselbalch Buffer pH-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Henderson-Hasselbalch Buffer pH-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Chemie & Wissenschaft",
    icon: "TestTube",
    featured: true,
    keywords: ["henderson-hasselbalch buffer ph-rechner","henderson-hasselbalch buffer ph calculator","buffer ph calculator","kostenloser online rechner"],
  },
  {
    slug: "led-resistor-calculator",
    enSlug: "led-resistor-calculator",
    name: "LED Series Current Limiting Resistor-Rechner",
    tagline: "LED Series Current Limiting Resistor-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem LED Series Current Limiting Resistor-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Ingenieurwesen & Elektronik",
    icon: "Zap",
    featured: true,
    keywords: ["led series current limiting resistor-rechner","led series current limiting resistor calculator","led resistor calculator","kostenloser online rechner"],
  },
  {
    slug: "gpa-raise-calculator",
    enSlug: "gpa-raise-calculator",
    name: "GPA Raising & Target Goal-Rechner",
    tagline: "GPA Raising & Target Goal-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem GPA Raising & Target Goal-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Noten & Bildung",
    icon: "Target",
    featured: true,
    keywords: ["gpa raising & target goal-rechner","gpa raising & target goal calculator","gpa raise calculator","kostenloser online rechner"],
  },
  {
    slug: "polynomial-roots-calculator",
    enSlug: "polynomial-roots-calculator",
    name: "Polynomial Roots & Quadratic/Cubic Factoring-Rechner",
    tagline: "Polynomial Roots & Quadratic/Cubic Factoring-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Polynomial Roots & Quadratic/Cubic Factoring-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Mathematik & Algebra",
    icon: "Binary",
    featured: true,
    keywords: ["polynomial roots & quadratic/cubic factoring-rechner","polynomial roots & quadratic/cubic factoring calculator","polynomial roots calculator","kostenloser online rechner"],
  },
  {
    slug: "decibel-calculator",
    enSlug: "decibel-calculator",
    name: "Decibel (dB) Sound & Power Gain-Rechner",
    tagline: "Decibel (dB) Sound & Power Gain-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Decibel (dB) Sound & Power Gain-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Ingenieurwesen & Elektronik",
    icon: "Volume2",
    featured: true,
    keywords: ["decibel (db) sound & power gain-rechner","decibel (db) sound & power gain calculator","decibel calculator","kostenloser online rechner"],
  },
  {
    slug: "empirical-formula-calculator",
    enSlug: "empirical-formula-calculator",
    name: "Empirical & Molecular Formula Chemistry-Rechner",
    tagline: "Empirical & Molecular Formula Chemistry-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Empirical & Molecular Formula Chemistry-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Chemie & Wissenschaft",
    icon: "FlaskConical",
    featured: true,
    keywords: ["empirical & molecular formula chemistry-rechner","empirical & molecular formula chemistry calculator","empirical formula calculator","kostenloser online rechner"],
  },
  {
    slug: "customer-lifetime-value-calculator",
    enSlug: "customer-lifetime-value-calculator",
    name: "Customer Lifetime Value (LTV / CLV)-Rechner",
    tagline: "Customer Lifetime Value (LTV / CLV)-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Customer Lifetime Value (LTV / CLV)-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Geschäft & Produktivität",
    icon: "Users",
    featured: true,
    keywords: ["customer lifetime value (ltv / clv)-rechner","customer lifetime value (ltv / clv) calculator","customer lifetime value calculator","kostenloser online rechner"],
  },
  {
    slug: "freelance-hourly-rate-calculator",
    enSlug: "freelance-hourly-rate-calculator",
    name: "Freelance Hourly & Daily Rate-Rechner",
    tagline: "Freelance Hourly & Daily Rate-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Freelance Hourly & Daily Rate-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Geschäft & Produktivität",
    icon: "Briefcase",
    featured: true,
    keywords: ["freelance hourly & daily rate-rechner","freelance hourly & daily rate calculator","freelance hourly rate calculator","kostenloser online rechner"],
  },
  {
    slug: "employee-turnover-cost-calculator",
    enSlug: "employee-turnover-cost-calculator",
    name: "Employee Turnover & Replacement Cost-Rechner",
    tagline: "Employee Turnover & Replacement Cost-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Employee Turnover & Replacement Cost-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Geschäft & Produktivität",
    icon: "UserMinus",
    featured: true,
    keywords: ["employee turnover & replacement cost-rechner","employee turnover & replacement cost calculator","employee turnover cost calculator","kostenloser online rechner"],
  },
  {
    slug: "customer-acquisition-cost-calculator",
    enSlug: "customer-acquisition-cost-calculator",
    name: "Customer Acquisition Cost (CAC) & Payback-Rechner",
    tagline: "Customer Acquisition Cost (CAC) & Payback-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Customer Acquisition Cost (CAC) & Payback-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Geschäft & Produktivität",
    icon: "Target",
    featured: true,
    keywords: ["customer acquisition cost (cac) & payback-rechner","customer acquisition cost (cac) & payback calculator","customer acquisition cost calculator","kostenloser online rechner"],
  },
  {
    slug: "working-capital-calculator",
    enSlug: "working-capital-calculator",
    name: "Working Capital & Current Ratio-Rechner",
    tagline: "Working Capital & Current Ratio-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Working Capital & Current Ratio-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Geschäft & Produktivität",
    icon: "Landmark",
    featured: true,
    keywords: ["working capital & current ratio-rechner","working capital & current ratio calculator","working capital calculator","kostenloser online rechner"],
  },
  {
    slug: "email-open-rate-click-through-calculator",
    enSlug: "email-open-rate-click-through-calculator",
    name: "Email Marketing Open Rate, CTR & Campaign ROI-Rechner",
    tagline: "Email Marketing Open Rate, CTR & Campaign ROI-Rechner kostenlos online. Sofortige Berechnung mit Formeln und Schritt-für-Schritt-Lösungen.",
    description: "Berechne einfach mit dem Email Marketing Open Rate, CTR & Campaign ROI-Rechner. Kostenloses Online-Tool ohne Registrierung mit 100% Datenschutz.",
    category: "Geschäft & Produktivität",
    icon: "Mail",
    featured: true,
    keywords: ["email marketing open rate, ctr & campaign roi-rechner","email marketing open rate, ctr & campaign roi calculator","email open rate click through calculator","kostenloser online rechner"],
  },
];

export function getDeCalculatorBySlug(slug: string): DeCalculatorMeta | undefined {
  return DE_CALCULATORS.find((c) => c.slug === slug || c.enSlug === slug);
}

export function getEnCalculatorSlugForDeSlug(deSlug: string): string {
  const found = DE_CALCULATORS.find((c) => c.slug === deSlug || c.enSlug === deSlug);
  return found ? found.enSlug : deSlug;
}

export function getDeCalculatorSlugForEnSlug(enSlug: string): string {
  const found = DE_CALCULATORS.find((c) => c.enSlug === enSlug || c.slug === enSlug);
  return found ? found.slug : enSlug;
}

export function relatedDeCalculators(currentSlug: string, count = 4): DeCalculatorMeta[] {
  const current = getDeCalculatorBySlug(currentSlug);
  return DE_CALCULATORS.filter((c) => c.slug !== current?.slug).slice(0, count);
}
